import styles from './DialogTitle.module.scss'
import React, {type ReactNode} from 'react'

interface DialogTitleProps {
    children?: ReactNode
}

export function DialogTitle({
    children,
}: DialogTitleProps) {
    return (
        <h2 className={styles.title}>
            {children}
        </h2>
    )
}
